import http from '@/api/Http'


export default{
    /**
     * 진료과전체 조회
     * @param {*} idno 
     * @returns 
     */
    async res0101s_f(pvid, hpno, pafg, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let param ={
            jobs: 'F',
            hpno: hpno,
            pafg: pafg,
            node: 'N'
        }
        let request = {
            svrm: ngit === 'MEDICARE' ? 'RES0101A': 'RES0101AN',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);
    },
    async res0101s_f2(pvid, hpno, pafg, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let param ={
            jobs: 'F',
            hpno: hpno,
            pafg: pafg,
            node: 'Y'
        }
        let request = {
            svrm: ngit === 'MEDICARE' ? 'RES0101A': 'RES0101AN',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);
    }, 
    async res0101s_f3(pvid, hpno, pafg, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let param ={
            jobs: 'F',
            hpno: hpno,
            pafg: pafg,
            node: 'N',
            remo: 'Y'
        }
        let request = {
            svrm: ngit === 'MEDICARE' ? 'RES0101A': 'RES0101AN',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);
    },   
    async selectDoctorInfo(providerId, hpno, dept, mddt, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }

        return http.post(`/api/defaultSet/selectDoctorInfo`,{ providerId, dept, hpno, mddt, ngit })
    },
    async selectDoctorInfoAll(providerId, hpno, dept, mddt, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let algb = 'Y'

        return http.post(`/api/defaultSet/selectDoctorInfo`,{ providerId, dept, hpno, mddt, ngit, algb })
    },    
    async res0202a_a(pvid, hpno, mddt, dept, doct, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let param ={
            jobs: 'A',
            hpno: hpno,
            mddt: mddt,
            dept: dept,
            doct: doct
        }
        let request = {
            svrm: ngit === 'MEDICARE' ? 'RES0202A': 'RES0202AN',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);        
    },
    async res0202a_b(pvid, hpno, mddt, dept, doct){
        let param ={
            jobs: 'B',
            hpno: hpno,
            mddt: mddt,
            dept: dept,
            doct: doct
        }
        let request = {
            svrm: 'RES0202A',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);        
    },
    async doctorInfo(providerId, doctorId){
        return http.post('/api/defaultSet/doctorInfo', { providerId, doctorId })
    },
    async urlToBase64(doctimag){
        return http.post(`/api/defaultSet/urlToBase64`,{ doctimag })
    },
    async sys0102a_g(pvid, idno, tokn){
        let param ={
            jobs: 'G',
            idno: idno,
            tokn: tokn
        }
        let request = {
            svrm: 'SYS0102A',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);        
    },  
    res0101a_i(pvid, hpno, pidn, ngit){
        if(ngit === undefined){
            ngit = 'MEDICARE'
        }
        let param ={
            jobs: 'I',
            hpno: hpno,
            pidn: pidn
        }
        let request = {
            svrm: ngit === 'MEDICARE' ? 'RES0101A': 'RES0101AN',
            pvid: pvid,
            param: param
        }
        return http.post(`/MediCare/agent/callNgtAgent`,request).then(r => r.data);
    },    
}